import { makeStyles } from "@material-ui/styles";

export const useHomeStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    cardFirstSubHead: {
      fontSize: "small",
      fontWeight: 600,
      color: "#051057",
    },
    cardAmountStyles: {
      fontSize: "2rem",
      fontWeight: "bolder",
      color: "#757575"
    },

    cardSecondSubHead: {
      fontSize: "small",
      fontWeight: 600,
      color: "#e91e63",
    }

  })
);
